module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9HYDH"))).then(() => parcelRequire('9Lwss'));